// Material-UI
import { Divider, Stack } from "@mui/material";
// Types
import { IRatingListProps } from "./interfaces";
// Components
import { RatingItem } from "./RatingItem";

export const RatingList = ({ data }: IRatingListProps) => {
	return (
		<Stack className="min-h-[320px]">
			{data?.map((item, index) => {
				if (index === data?.length - 1) {
					return (
						<Stack key={`rating_${item?.label}_${index}`}>
							<Divider className="!my-[8px] w-full" />
							<RatingItem key={item.label} item={item} />
						</Stack>
					);
				}
				return <RatingItem key={item.label} item={item} />;
			})}
		</Stack>
	);
};
